module.exports = __webpack_public_path__ + "img/report.07017594.png";